import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AdminService } from '../admin.service';
import { UserService } from 'src/app/core/services/user.service';
import { User } from 'src/app/core/models/user';
import { HolidayModel } from 'src/app/core/models/HolidayModel';
import { Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { Constants } from 'src/app/constants/constants';
import { NzModalService } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-holiday',
  standalone: false,
  templateUrl: './holiday.component.html',
  styleUrl: './holiday.component.less'
})
export class HolidayComponent  implements OnInit {
  holidayForm!: FormGroup;
  isModalVisible = false;
  currentUser: User = new User();
  hoildayMaster: HolidayModel[] = [];
  allHolidays: HolidayModel[] = [];
  addHolidayDetail: HolidayModel = new HolidayModel();
  duplicateRecordMessge: string = "";
  selectedYear = 0;

  config: any;
  currentPageSize = 10;
  sortingName: string = "Date";
  isDesc: boolean = false;

  years: number[] = [];
  holidays: { holidayName: string; holidayDate: string }[] = [];

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private adminService: AdminService,
    private userService: UserService,
    private messageService: NzMessageService,
    private modalService: NzModalService
  ) {
    
  }

  ngOnInit() {
    this.addHolidayDetail = new HolidayModel();
    this.currentUser = this.userService.getCurrentUser();  
    if (this.currentUser?.User_Code == null) {
      this.userService.userUpdated.subscribe((updatedUser: User) => {
        this.currentUser = updatedUser;
        this.initialLoading();
      }); 
    }else{
      this.initialLoading();
    }
  }
  initialLoading() {
    
    if (this.currentUser?.User_Code == null) {
      window.location.href = '/';
    }
    if (this.currentUser.IsRFCAdmin) {
      this.initializeData();
      this.getAllHolidays();
    }
    else {
      
      //this.router.navigate(['/unauthorize']);
    }
  }
  initializeData() {
    this.holidayForm = this.fb.group({
      holidayName: ['', [Validators.required, Validators.maxLength(50)]],
      holidayDate: ['', [Validators.required]]
    });
    this.config = {
      itemsPerPage: this.currentPageSize,
      currentPage: 1,
      totalItems: this.hoildayMaster.length
    }
  }

  getAllHolidays() {
    this.adminService.getAllHolidays().subscribe((response: any) => {      
      this.allHolidays = response.output.filter((x:any) => x.Active);
      this.years = response.years;
      this.onYearChanged();
      
    });
  }
  onYearChanged() {
    this.config.currentPage = 1;    
    this.hoildayMaster = (this.selectedYear == 0) ? this.allHolidays : this.allHolidays.filter(item => new Date(item.Date).getFullYear().toString() == this.selectedYear.toString());
    this.hoildayMaster = this.hoildayMaster.sort((a, b) => new Date(b.Date).getTime() - new Date(a.Date).getTime());
  }
  onChangeYear(value: any): void {
    this.selectedYear = value == null ? 0 : value;
    this.onYearChanged();
  }
  openAddHolidayModal(): void {
    this.isModalVisible = true;
    this.holidayForm.reset();
  }

  closeModal(): void {
    this.holidayForm.reset(); // Reset the form to clear validation errors
    this.isModalVisible = false;
  }

  submitForm(): void {
    if (this.holidayForm.valid) {
      this.holidays.push(this.holidayForm.value);
      this.addHolidayDetail = new HolidayModel();
      this.addHolidayDetail.Name = this.holidayForm.value.holidayName;
      this.addHolidayDetail.Date = this.holidayForm.value.holidayDate;
      this.addHolidayDetail.Active = true;
      this.addHolidayDetail.Created_By = this.currentUser.User_Code??0;
 
      this.addHoliday();
      //this.closeModal();
    } else {
      this.holidayForm.markAllAsTouched();
    }
  }
  addHoliday() {
    var record = this.allHolidays.filter(s => new Date(s.Date).getFullYear() == new Date(this.addHolidayDetail.Date).getFullYear()
                                                  && new Date(s.Date).getMonth() == new Date(this.addHolidayDetail.Date).getMonth()
                                                  && new Date(s.Date).getDate() == new Date(this.addHolidayDetail.Date).getDate());
    if (record.length > 0) {
      this.duplicateRecordMessge = 'Holiday already exist';
    }
    else {      
      this.addHolidayDetail.Created_By = this.currentUser.User_Code??0;
      this.adminService.addHoliday(this.addHolidayDetail).subscribe((response: any) => {
        if (response.result) {
          this.messageService.success("Holiday added successfully", { nzDuration: Constants.SHOW_MESSAGE_DURATION });
          this.getAllHolidays();
        }
        else {
          this.messageService.error("Error occurred while adding holiday");
        }
        this.resetToDefault();
      });
    }
  }
  resetToDefault() {
    this.addHolidayDetail = new HolidayModel();
    this.duplicateRecordMessge = "";
    this.closeModal();
  }
  disablePastDates = (current: Date): boolean => {
    return current && current.getTime() < new Date().setHours(0, 0, 0, 0);
  };

  editHoliday(holiday: any): void {
    // Logic to edit holiday
  }

  deleteHolidayModal(holiday: HolidayModel): void {    
    this.modalService.confirm({
      nzTitle: 'Confirm!',
      nzContent: `Are you sure, you want to delete holiday? - <strong>${holiday.Name}</strong>?`,
      nzOkText: 'Yes',
      nzOkType: 'primary',
      nzWidth: 600,
      nzClosable: false,
      nzOkDanger: true,
      nzOnOk: () => this.deleteHoliday(holiday.Holiday_Id),
      nzCancelText: 'No'
    });
  }
  deleteHoliday(holidayId: any) {
    this.adminService.deleteHoliday(holidayId, this.currentUser.User_Code).subscribe((response: any) => {
      if (response.result) {
        this.messageService.success("Holiday deleted successfully!", { nzDuration: Constants.SHOW_MESSAGE_DURATION });
        this.duplicateRecordMessge = "";
        this.getAllHolidays();
      }
      else {
        this.messageService.error("Error occurred while deleting holiday");
      }
      this.resetToDefault();
    });
  }
  
}
